export class SurgicalProcedure {
  dt?: string;
  firstname?: string;
  coding_id?: number;
  major?: string;
  patient_id?: number;
  description?: string;
  procedure_date?: string;
  version_id?: number;
  status?: number;
  lastname?: string;
  [key: string]: any;
}
